import { createSafeContext } from '@lib/utils';

export type TimelineVariant = 'filled' | 'outlined';

export interface TimelineContextType {
  variant: TimelineVariant;
}

export const [TimelineContext, useTimelineContext] = createSafeContext<TimelineContextType>(
  'useTimelineContext must be used within Timeline'
);
